import {createSlice, PayloadAction} from "@reduxjs/toolkit";

type LoadingState = {
    loading: boolean,
    ok: boolean,
    error: string,
    activeCallsCount?: number  // Track concurrent API calls (optional for backward compatibility)
}

let initialState: LoadingState = {
    loading: false,
    ok: true,
    error: "",
    activeCallsCount: 0,
};


const loadingSlice = createSlice({
    name: 'Loading',
    initialState: initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading=action.payload;
        },
        setOk(state, action: PayloadAction<boolean>) {
            state.ok=action.payload;
        },
        setError(state, action: PayloadAction<string>) {
            state.error=action.payload;
        },
        setAllStates(state, action: PayloadAction<LoadingState>) {
            state.loading=action.payload.loading;
            state.ok=action.payload.ok;
            state.error=action.payload.error;
            // Don't modify activeCallsCount when using setAllStates (for backward compatibility)
        },
        // New counter-based loading management
        startLoading(state) {
            state.activeCallsCount = (state.activeCallsCount || 0) + 1;
            state.loading = true;
            // Don't change ok/error when starting a new call
        },
        stopLoading(state, action: PayloadAction<{success: boolean, error?: string}>) {
            state.activeCallsCount = Math.max(0, (state.activeCallsCount || 0) - 1);

            // Only set loading to false when all API calls are complete
            if (state.activeCallsCount === 0) {
                state.loading = false;
            }

            // Update ok status based on this call's result
            if (!action.payload.success) {
                state.ok = false;
                state.error = action.payload.error || "An error occurred";
            } else if (state.activeCallsCount === 0) {
                // Only reset ok/error when all calls are done and successful
                state.ok = true;
                state.error = "";
            }
        },
    }
});



export const {setLoading, setOk, setError, setAllStates, startLoading, stopLoading} = loadingSlice.actions;

export default loadingSlice.reducer